<mat-card>
  <h2 translate>adminReport.title</h2>
  <form [formGroup]="adminReportForm">
    <mat-grid-list cols="15" rowHeight="80px">
      <mat-grid-tile colspan="3">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>adminReport.codHost</mat-label>
          <input id="codHost" formControlName="codHost" matInput type="text" maxlength="30" autocomplete="off" />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile colspan="3">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="division"
          [id]="'division'"
          [dataInput]="divisionList"
          [placeholder]="'adminReport.division'"
          [isRequired]="true"
          [showErrors]="adminReportForm?.controls?.division?.errors"
        ></scf-custom-select-search>
      </mat-grid-tile>

      <mat-grid-tile colspan="3">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="typeBS"
          [id]="'typeBS'"
          [dataInput]="tipoBSList"
          [placeholder]="'adminReport.typeBS'"
          [showErrors]="adminReportForm?.controls?.typeBS?.errors"
          (selectionChange)="onTypeBsSelectionChange($event.value)"
        ></scf-custom-select-search>
      </mat-grid-tile>

      <mat-grid-tile colspan="3">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="attribution"
          [id]="'attribution'"
          [dataInput]="attributionList"
          [placeholder]="'adminReport.attribution'"
          [showErrors]="adminReportForm?.controls?.attribution?.errors"
          (selectionChange)="onAttributionSelected()"
        ></scf-custom-select-search>
      </mat-grid-tile>

      <mat-grid-tile colspan="3">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="perfil"
          [id]="'perfil'"
          [dataInput]="profilesList"
          [placeholder]="'adminReport.perfil'"
          [showErrors]="adminReportForm?.controls?.perfil?.errors"
          (selectionChange)="onPerfilSelected()"
        ></scf-custom-select-search>
      </mat-grid-tile>
    </mat-grid-list>

    <mat-grid-list cols="15" rowHeight="20px">
      <mat-grid-tile colspan="15">
        <mat-label class="subtitles" translate>adminReport.highDate</mat-label>
      </mat-grid-tile>
    </mat-grid-list>

    <mat-grid-list cols="15" rowHeight="80px">
      <mat-grid-tile colspan="6">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>adminReport.dateInit</mat-label>
          <input id="dateInit" formControlName="dateInit" matInput [matDatepicker]="dateInit" autocomplete="off" />
          <mat-datepicker-toggle matSuffix [for]="dateInit"></mat-datepicker-toggle>
          <mat-datepicker #dateInit></mat-datepicker>
          <mat-error *ngIf="adminReportForm.errors?.dateInvalid" translate>field.error.dateInitial</mat-error>
          <mat-error *ngIf="adminReportForm.controls.dateInit.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile colspan="6">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>adminReport.dateEnd</mat-label>
          <input
            id="dateEnd"
            formControlName="dateEnd"
            matInput
            [matDatepicker]="dateEnd"
            [min]="adminReportForm.controls.dateInit?.value"
            autocomplete="off"
          />
          <mat-datepicker-toggle matSuffix [for]="dateEnd"></mat-datepicker-toggle>
          <mat-datepicker #dateEnd></mat-datepicker>
          <mat-error *ngIf="adminReportForm.errors?.dateInvalid" translate>field.error.dateFinal</mat-error>
          <mat-error *ngIf="adminReportForm.controls.dateEnd.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>

    <mat-grid-list cols="15" rowHeight="20px">
      <mat-grid-tile colspan="15">
        <mat-label class="subtitles" translate>adminReport.lowDate</mat-label>
      </mat-grid-tile>
    </mat-grid-list>

    <mat-grid-list cols="15" rowHeight="80px">
      <mat-grid-tile colspan="6">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>adminReport.dateInitLow</mat-label>
          <input
            id="dateInitLow"
            formControlName="dateInitLow"
            matInput
            [min]="minDateInit"
            [matDatepicker]="dateInitLow"
            autocomplete="off"
          />
          <mat-datepicker-toggle matSuffix [for]="dateInitLow"></mat-datepicker-toggle>
          <mat-datepicker #dateInitLow></mat-datepicker>
          <mat-error *ngIf="adminReportForm.errors?.dateLowInvalid" translate>field.error.dateInitial</mat-error>
          <mat-error *ngIf="adminReportForm.controls.dateInitLow.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile colspan="6">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>adminReport.dateEndLow</mat-label>
          <input
            id="dateEndLow"
            formControlName="dateEndLow"
            matInput
            [min]="adminReportForm.controls.dateInitLow?.value"
            [matDatepicker]="dateEndLow"
            autocomplete="off"
          />
          <mat-datepicker-toggle matSuffix [for]="dateEndLow"></mat-datepicker-toggle>
          <mat-datepicker #dateEndLow></mat-datepicker>
          <mat-error *ngIf="adminReportForm.errors?.dateLowInvalid" translate>field.error.dateFinal</mat-error>
          <mat-error *ngIf="adminReportForm.controls.dateEndLow.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>

    <mat-grid-list cols="20" rowHeight="80px">
      <mat-grid-tile colspan="10">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="internal"
          [id]="'internal'"
          [dataInput]="commercialInternalList"
          [placeholder]="'adminReport.internal'"
          [showErrors]="adminReportForm?.controls?.internal?.errors"
        ></scf-custom-select-search>
      </mat-grid-tile>
      <mat-grid-tile colspan="10">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="external"
          [id]="'external'"
          [dataInput]="commercialExternalList"
          [placeholder]="'adminReport.external'"
          [showErrors]="adminReportForm?.controls?.external?.errors"
        ></scf-custom-select-search>
      </mat-grid-tile>
    </mat-grid-list>

    <mat-grid-list cols="10" rowHeight="80px">
      <mat-grid-tile colspan="7">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="office"
          [id]="'office'"
          [dataInput]="officesList"
          [placeholder]="'adminReport.office'"
          [showErrors]="adminReportForm?.controls?.office?.errors"
        ></scf-custom-select-search>
      </mat-grid-tile>

      <mat-grid-tile colspan="3">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="active"
          [id]="'active'"
          [dataInput]="activadoList"
          [placeholder]="'adminReport.active'"
          [showErrors]="adminReportForm?.controls?.active?.errors"
        ></scf-custom-select-search>
      </mat-grid-tile>
    </mat-grid-list>

    <mat-grid-list cols="15" rowHeight="80px">
      <mat-grid-tile colspan="3"> </mat-grid-tile>

      <mat-grid-tile colspan="3">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="orden1"
          [id]="'orden1'"
          [dataInput]="ordenList"
          [placeholder]="'adminReport.orden1'"
          [showErrors]="adminReportForm?.controls?.orden1?.errors"
        ></scf-custom-select-search>
      </mat-grid-tile>

      <mat-grid-tile colspan="3">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="orden2"
          [id]="'orden2'"
          [dataInput]="ordenList"
          [placeholder]="'adminReport.orden2'"
          [showErrors]="adminReportForm?.controls?.orden2?.errors"
        ></scf-custom-select-search>
      </mat-grid-tile>

      <mat-grid-tile colspan="3">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="orden3"
          [id]="'orden3'"
          [dataInput]="ordenList"
          [placeholder]="'adminReport.orden3'"
          [showErrors]="adminReportForm?.controls?.orden3?.errors"
        ></scf-custom-select-search>
      </mat-grid-tile>

      <mat-grid-tile colspan="3"> </mat-grid-tile>
    </mat-grid-list>

    <mat-grid-list cols="15" rowHeight="80px">
      <mat-grid-tile colspan="15">
        <div fxFlex="100" class="btn">
          <button
            id="sendButtonRequest"
            mat-flat-button
            color="accent"
            (click)="exportReportAdmin()"
            [disabled]="btnSendDisabled"
          >
            {{ 'adminReport.btn' | translate | uppercase }}
          </button>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </form>
</mat-card>
